import { Power0, Power3, TweenLite } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import { ajaxSubmitForm } from '../util/forms'
import BreakpointHelpers from '../util/breakpointHelpers'

const bpHelpers = new BreakpointHelpers()

export default {
  init () {
    // Enquiry
    const enquiryTimeline = new TimelineMax({ paused: true })
    const $productEnquiry = $('.product-enquiry')
    const $productEnquiryImage = $productEnquiry.findElement('image')
    const $productEnquiryDrawer = $productEnquiry.findElement('drawer')
    let enquiryOpen = false

    // Header reposition stuff
    const breakpoint = bpHelpers.determineBreakpoint(window.innerWidth)
    let headerY
    switch (breakpoint) {
      case 'xs':
        headerY = '0px'
        break
      case 'sm':
      case 'md':
      case 'lg':
      case 'xl':
        headerY = '-20px'
        break
    }

    TweenLite.to(
      $('.logo'),
      0.3,
      { y: headerY, ease: Power3.easeOut }
    )

    enquiryTimeline
      .to(
        $productEnquiry,
        0.0001,
        { autoAlpha: 1 }
      )
      .to(
        $productEnquiryDrawer,
        0.6,
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        $productEnquiryDrawer.findElement('cta'),
        0.3,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: Power0.easeNone },
        0.3
      )
      .to(
        [
          $productEnquiryImage.get(0),
          $productEnquiryImage.find('.bg').get(0),
        ],
        0.6,
        { x: '0%', ease: Power3.easeInOut },
        0
      )

    // Workaround so that recaptcha initiates after an ajax load
    let captchaLoaded = false
    function loadCaptchaScript () {
      if (typeof window.recaptcha === 'undefined') {
        const $scripts = $('.form-group > .recaptcha script')
        $scripts.each(function (i, el) {
          const src = $(el).attr('src')
          if (typeof src === 'undefined') {
            $.globalEval(el.innerHTML)
          } else {
            $.getScript(src)
          }
        })
        if (typeof window.onload === 'function') {
          window.onload.apply()
        }
      }

      captchaLoaded = true
    }

    $('.js-product-enquiry-toggle').click(function (event) {
      event.preventDefault()
      if (!enquiryOpen) {
        if (!captchaLoaded) {
          loadCaptchaScript()
        }
        enquiryTimeline.play()
      } else {
        enquiryTimeline.reverse()
      }
      enquiryOpen = !enquiryOpen
      $('html').toggleClass('no-scroll', enquiryOpen)
    })

    // Form

    window._submitEvent = function () {
      const extraData = { action: 'submit_enquiry_form' }

      if ($('#g-recaptcha-response').length !== 0) {
        extraData['g-recaptcha-response'] = $('#g-recaptcha-response').val()
      }

      ajaxSubmitForm(
        $('.enquiry-form'),
        function (data, $form) {
          if (data.submission) {
            $form
              .find('.form-success')
              .append(data.message)
              .show()
              .siblings('.form-fields')
              .hide()
          } else {
            $form
              .find('.form-errors')
              .append(data.message)
              .show()
          }
        },
        this,
        extraData
      )
    }

    // Hover Effects
    $('body').on('mouseenter', '.product-related-listed', function (event) {
      $(this).data('timelineHover').play()
    })

    $('body').on('mouseleave', '.product-related-listed', function (event) {
      $(this).data('timelineHover').reverse()
    })
  },
  finalize () {
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js